<script lang="ts">
	//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from '../../../../services/http';
	//Configs
	import { devices_config } from '@devices/index';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	import { changeFirmware } from '../../../../helpers/rgbw2_fw_update';
	import {
		checkSharedChannels,
		unshareAllChannels,
		type SharedChannelData,
	} from '../../../../helpers/profile_change_shared_helper';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	//Components
	import ModalPrompt from '../../../../components/ModalPrompt.svelte';
	import ProfileChangeSharedModal from '../SettingsG2/ProfileChangeSharedModal.svelte';
	import { capFirstChar } from 'src/helpers/utilities';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	let localIp = get_local_ip(id);

	let mode = settings?.mode;
	let cacheMode = mode;
	let modes = ['color', 'white'];
	let loading = false;
	let options = [
		$format('option_device_type_color', {
			default: 'Color - this mode mode controls Red, Blue, Green and White LED stripes.',
		}),
		$format('option_device_type_white', {
			default: 'White - this mode controls 4 white LED stripes.',
		}),
	];
	let showModal = false;
	let showSharedModal = false;
	let props: { e?; value?; title?; text?; callback?; button_1?; button_2? } = {};
	let sharedChannelsData: SharedChannelData[] = [];

	const removeChannels = async (id) => {
		let idsToRemove = [];

		for (let i = 0; i < devices_config[device.type].modes[settings.mode].channels; i++) {
			if (i > 0) {
				idsToRemove.push(`${id}_${i}`);
			}
		}

		const res = await postReq(`/interface/device/bulk_delete`, {
			ids: JSON.stringify(idsToRemove),
		});

		if (res.isok) {
			idsToRemove.map((id) => {
				devices.remove(id);
			});
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};
	const setMode = async (_mode) => {
		mode = _mode;
		switch (_mode) {
			case 'white':
				await changeFirmware(device, _mode, localIp);
				break;
			case 'color':
				await changeFirmware(device, _mode, localIp);
				await removeChannels(id);
				break;
			default:
				break;
		}
	};

	const handleSharedModalConfirm = async () => {
		showSharedModal = false;
		await unshareAllChannels(sharedChannelsData);
		openModal(mode);
	};
	const openModal = (_mode) => {
		showModal = true;
		props = {
			// title: $format('modal_title_mode_change', { default: 'Mode change' }),
			title: capFirstChar($format('sub_settings_title_firmware_version')),
			value: _mode,
			callback: setMode,
			button_1: $format('button_update'),
			button_2: $format('button_cancel'),
			text: $format('alert_change_mode_updates_fw', {
				default:
					"This mode will change you device's current firmware. This might take up to 5 minutes. Do you want to continue?",
			}),
		};
	};
	const changeMode = (_mode) => {
		mode = _mode;
	};

	const promptChangeMode = async () => {
		if (mode === cacheMode) return;

		const channelsData = await checkSharedChannels(device);

		if (channelsData.length > 0) {
			sharedChannelsData = channelsData;
			showSharedModal = true;
			return;
		}

		if (mode !== cacheMode) {
			openModal(mode);
		}
	};
</script>

{#each modes as _mode, i}
	<Radio
		size="m"
		bind:selected={mode}
		value={_mode}
		on:click={() => changeMode(_mode)}
		id="radio-nilvaw9">{options[i]}</Radio
	>
{/each}
<Button class="mt-s" {loading} size="m" width="full" on:click={promptChangeMode}
	>{$format('button_save')}</Button
>
{#if sharedChannelsData.length > 0}
	<ProfileChangeSharedModal bind:showModal={showSharedModal} on:confirm={handleSharedModalConfirm} />
{/if}
{#if showModal}
	<ModalPrompt bind:showModal {props} />
{/if}
